import * as React from 'react';

import { Dispatch } from 'redux';
import { connect, useSelector } from 'react-redux';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import { Country } from '@common/types/data/country';
import { isUsername } from '@services/utils/validators';

import AppState from '@webapp/store/state';
import { ForgotPasswordStart } from '@webapp/store/auth/action-creators';
import { ResetError } from '@webapp/store/ui/action-creators';
import {
  FORGOT_PASSWORD_START,
  FORGOT_PASSWORD_START_ERROR,
  FORGOT_PASSWORD_ERROR,
} from '@webapp/store/auth/actions';

import EmailOrPhoneCtrl, {
  DEFAULT_COUNTRY,
} from '@webapp/controllers/form/email-or-phone';

import Flex from '@components/layout/flex';
import ButtonArrow from '@components/actions/arrow-button';

interface ForgotPasswordCtrlProps {
  className?: string;
  isLoading: boolean;
  forgotPassword: (username: string) => ForgotPasswordStart;
  resetForgetPasswordError: () => ResetError;
}

const mapStateToProps = (state: AppState) => ({
  isLoading: !!state.ui.loading[FORGOT_PASSWORD_START],
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  forgotPassword: (username: string) =>
    dispatch(new ForgotPasswordStart(username)),
  resetForgetPasswordError: () =>
    dispatch(new ResetError(FORGOT_PASSWORD_ERROR)),
});

export const ForgotPasswordCtrl: React.FC<ForgotPasswordCtrlProps> = (
  props
) => {
  const [username, setUsername] = React.useState('');
  const [emptyUsername, setEmptyUsername] = React.useState(true);
  const [isInvalidUsername, setIsInvalidUsername] = React.useState(false);
  const [country, setCountry] = React.useState<Country>(DEFAULT_COUNTRY);

  const handleSubmit = (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    props.resetForgetPasswordError();
    if (username.length === 0) {
      setIsInvalidUsername(true);
    }
    if (isUsername(username)) {
      props.forgotPassword(username);

      setUsername('');
    }
  };

  const forgotPasswordError = useSelector(
    (state: AppState) => !!state.ui.errors[FORGOT_PASSWORD_START_ERROR]
  );

  return (
    <form
      autoComplete="off"
      className={props.className}
      onSubmit={(ev) => handleSubmit(ev)}
    >
      <Flex
        className="wrapper"
        alignItems="center"
        justifyContent="space-between"
        gap={10}
      >
        <EmailOrPhoneCtrl
          className="input"
          value={username}
          country={country}
          onChange={(value) => {
            setUsername(value.value);
            setIsInvalidUsername(false);
          }}
          onInputChange={(value) =>
            setEmptyUsername(!!value?.length ? false : true)
          }
          onCountryChange={(value) => setCountry(value)}
          isGrey
          error={
            forgotPasswordError || isInvalidUsername ? (
              <Translate id="InvalidParameterException" />
            ) : undefined
          }
        />
        <ButtonArrow
          id="forgotPassword"
          type="submit"
          className="button-arrow"
          isLoading={!!props.isLoading}
          disabled={emptyUsername}
        />
      </Flex>
    </form>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(ForgotPasswordCtrl)`
  display: flex;
  .wrapper {
    width: 100%;
  }
  .input {
    flex-grow: 1;
  }
  .button-arrow {
    max-width: 78px;
  }
`);
